import DashboardLayout from '@/pages/Layout/DashboardLayout.vue'

import Dashboard from '@/pages/Dashboard.vue'

// import Packages from '@/pages/Packages.vue'
// import PackagesView from '@/pages/Packages/View.vue'
// import PackagesDetail from '@/pages/Packages/Detail.vue'
// import PackagesEdit from '@/pages/Packages/Edit.vue'
// import PackagesNew from '@/pages/Packages/New.vue'

import Settings from '@/pages/Settings.vue'
import SettingsView from '@/pages/Settings/View.vue'

// import Zones from '@/pages/Zones.vue'
// import ZonesView from '@/pages/Zones/View.vue'
// import ZonesEdit from '@/pages/Zones/Edit.vue'

import Clients from '@/pages/Clients.vue'
import ClientsView from '@/pages/Clients/View.vue'
import ClientsEdit from '@/pages/Clients/Edit.vue'
import ClientsRenew from '@/pages/Clients/Renew.vue'
import ClientsDetail from '@/pages/Clients/Detail.vue'

import Branch from '@/pages/Branch.vue'
import BranchView from '@/pages/Branch/View.vue'
import BranchEdit from '@/pages/Branch/Edit.vue'
import BranchDetail from '@/pages/Branch/Detail.vue'

// import Payments from '@/pages/Payments.vue'
// import PaymentsView from '@/pages/Payments/View.vue'
// import PaymentsDetail from '@/pages/Payments/Detail.vue'

import Package from '@/pages/Package.vue'
import PackageView from '@/pages/Package/View.vue'
import PackageEdit from '@/pages/Package/Edit.vue'
import PackageDetail from '@/pages/Package/Detail.vue'

import Stats from '@/pages/Stats.vue'
import StatsView from '@/pages/Stats/View.vue'

import CheckIn from '@/pages/CheckIn.vue'
// import PrintPayment from '@/pages/PrintPayment.vue'
// import PrintPaymentDriver from '@/pages/PrintPaymentDriver.vue'
// import PrintPaymentDriverPickup from '@/pages/PrintPaymentDriverPickup.vue'
// import PrintPaymentReferral from '@/pages/PrintPaymentReferral.vue'

// import Transactions from '@/pages/Transactions.vue'
// import TransactionsView from '@/pages/Transactions/View.vue'
// import TransactionsDetail from '@/pages/Transactions/Detail.vue'

import Administrators from '@/pages/Administrators.vue'
import AdministratorsView from '@/pages/Administrators/View.vue'
import AdministratorsEdit from '@/pages/Administrators/Edit.vue'



const routes = [
	{
		path: '/',
		component: DashboardLayout,
		redirect: '/dashboard',
		children: [
			{
				path: 'dashboard',
				name: 'ផ្ទាំងទាំងអស់',
				component: Dashboard
			},
			{
				path: 'settings',
				component: Settings,
				children: [
					{
						path: '',
						name: "Settings",
						component: SettingsView
					}
				]
			},
			{
				path: 'packages',
				component: Package,
				children: [
					{
						path: '',
						name: "ការគ្រប់គ្រងអ្នកដឹកជញ្ជូន",
						component: PackageView
					},
					{
						path: 'edit/:hash_id',
						name: "ការគ្រប់គ្រងអ្នកដឹកជញ្ជូន",
						component: PackageEdit
					},
					{
						path: 'detail/:hash_id',
						name: "ការគ្រប់គ្រងអ្នកដឹកជញ្ជូន",
						component: PackageDetail
					}
				]
			},
			{
				path: 'check_in',
				name: "បង្កើតកញ្ចប់ឥវ៉ាន់ថ្មី",
				component: CheckIn,
			},

			{
				path: 'clients',
				component: Clients,
				children: [
					{
						path: '',
						name: "ការគ្រប់គ្រងអតិថិជន",
						component: ClientsView
					},
					{
						path: 'detail/:hash_id',
						name: "ការគ្រប់គ្រងអតិថិជន",
						component: ClientsDetail
					},
					{
						path: 'edit/:hash_id',
						name: "ការគ្រប់គ្រងអតិថិជន",
						component: ClientsEdit
					},
					{
						path: 'renew/:hash_id',
						name: "ការគ្រប់គ្រងអតិថិជន",
						component: ClientsRenew
					}
				]
			},
			{
				path: 'branch',
				component: Branch,
				children: [
					{
						path: '',
						name: "ការគ្រប់គ្រងអ្នកទីផ្សា",
						component: BranchView
					},
					{
						path: 'detail/:hash_id',
						name: "ការគ្រប់គ្រងអ្នកទីផ្សា",
						component: BranchDetail
					},
					{
						path: 'edit/:hash_id',
						name: "ការគ្រប់គ្រងអ្នកទីផ្សា",
						component: BranchEdit
					}
				]
			},

			{
				path: 'stats',
				component: Stats,
				children: [
					{
						path: '',
						name: "ទិន្នន័យស្ថិតិ",
						component: StatsView
					}
				]
			},
			{
				path: 'administrators',
				component: Administrators,
				children: [
					{
						path: '',
						name: "Administrators",
						component: AdministratorsView
					},
					{
						path: 'edit/:id',
						name: 'Administrators',
						component: AdministratorsEdit
					}
				]
			}
		]
	}
]

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js